import { Flex, Text } from '@hivewatch/dark'

interface DrawerMessageContainerIProps {
  title: string
  message: string
}

export const DrawerMessageContainer = ({
  title,
  message,
}: DrawerMessageContainerIProps) => {
  return (
    <Flex
      alignItems='center'
      display='flex'
      flex={1}
      flexDir='column'
      justifyContent='center'
      p={4}
    >
      <Text fontSize='18px' fontWeight={700}>
        {title}
      </Text>
      <Text fontSize='14px' fontWeight={500}>
        {message}
      </Text>
    </Flex>
  )
}
